import Autoplay from "embla-carousel-autoplay";
import { createCarousel } from "@/ui/carousel/carousel";
import "./section-logos.css";

export const createSectionLogos = () => {
  const container = document.querySelector<HTMLElement>(
    ".carousel.logos-carousel",
  );

  if (container !== null) {
    const carousel = createCarousel(
      container,
      {
        loop: true,
        duration: 10000,
      },
      [
        Autoplay({
          delay: 0,
        }),
      ],
    );

    carousel.plugins().autoplay?.play();
  }
};
